import { Reveal, RevealWords } from "./Motion";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "IYM hat unsere Website komplett neu gedacht. Die Anfragen kamen sofort, professionell, schnell und mit einem tollen Blick fürs Detail.",
    name: "Michael K.",
    role: "Geschäftsführer, MKS Solar",
    initials: "MK",
  },
  {
    quote:
      "Endlich eine Agentur, die Design UND Google Ads versteht. Unser ROAS hat sich in wenigen Wochen mehr als verdoppelt.",
    name: "Sarah L.",
    role: "Marketing, ViralUp",
    initials: "SL",
  },
  {
    quote:
      "Vom ersten Gespräch bis zum Launch alles reibungslos. Die Seite sieht hochwertig aus und bringt echte Mandanten.",
    name: "Dr. Weber",
    role: "Der Steuerberater",
    initials: "DW",
  },
];

export default function Testimonials() {
  return (
    <section id="stimmen" className="mx-auto max-w-[1360px] px-5 py-24 md:px-10 md:py-36">
      <div className="mb-16">
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.2em] text-[#2c3bff]">/ Kundenstimmen</p>
        <h2 className="max-w-2xl font-display text-4xl leading-[0.95] text-ink sm:text-5xl md:text-6xl">
          <RevealWords text="Was Kunden über uns sagen." />
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <figure
              data-testid={`testimonial-${i}`}
              className="flex h-full flex-col justify-between rounded-2xl border border-black/10 bg-white p-8"
            >
              <Quote className="h-8 w-8 text-[#2c3bff]" />
              <blockquote className="mt-6 font-display text-xl leading-snug text-ink">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#2c3bff] font-display text-sm text-white">
                  {t.initials}
                </span>
                <div>
                  <div className="font-display text-ink">{t.name}</div>
                  <div className="font-mono text-xs uppercase tracking-wider text-[#8a857b]">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
